import { Permissions } from '../../core/enums/permissions.enum'
import { LayersDefinition } from '../models/layers-definition.model'

export const Layers: LayersDefinition = {
  RolloutsTile: {
    name: 'rt',
    permissions: [Permissions.VZO_Apps_Internal, Permissions.VZO_Apps_Customer],
  },
  RolloutsMatchedSignsTile: {
    name: 'rmst',
    permissions: [Permissions.VZO_Apps_Internal, Permissions.VZO_Apps_Customer],
  },
  RolloutsFilteredMatchedSignsTile: {
    name: 'rfmst',
    permissions: [Permissions.VZO_Apps_Internal, Permissions.VZO_Apps_Customer],
  },

  Provider1Observations: {
    name: 'p1_obs',
    permissions: [Permissions.VZO_Observations_Read],
  },
  Provider2Observations: {
    name: 'p2_obs',
    permissions: [Permissions.VZO_Observations_Read],
  },

  ClusteredSigns: {
    name: 'cls',
    permissions: [Permissions.VZO_ClusteredSigns_Read],
  },
  NonDetections: {
    name: 'nd',
    permissions: [Permissions.VZO_ClusteredSigns_Read],
  },

  MatchedSigns: {
    name: 'ms',
    permissions: [Permissions.VZO_MatchedSigns_Read],
  },

  ConstructionSites: {
    name: 'cs',
    permissions: [Permissions.VZO_ConstructionSites_Read],
  },

  BlacklistAreas: {
    name: 'bla',
    permissions: [Permissions.VZO_Apps_Internal],
  },
  RoadCoverage: {
    name: 'rc',
    permissions: [Permissions.VZO_Apps_Internal],
  },
  SpeedProfile: {
    name: 'sp',
    permissions: [Permissions.VZO_Apps_Internal],
  },
}
